import { useCallback, useState } from 'react';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { RootStackParamList } from '@/navigation/types';
import { logger } from '@/utils/logging';

const LOG_TAG = '[CasinoGameWebView]';

export const useCasinoGameRecovery = (gameId: string) => {
    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
    const [reloadAttempt, setReloadAttempt] = useState(0);
    const [showErrorOverlay, setShowErrorOverlay] = useState(false);

    // No auto-remount: on low-memory devices the renderer can die again straight away, so the user picks retry.
    const onProcessTerminated = useCallback(
        (didCrash?: boolean) => {
            logger.error(LOG_TAG, 'WebView content process terminated', { gameId, didCrash });
            setShowErrorOverlay(true);
        },
        [gameId]
    );

    const retry = useCallback(() => {
        setShowErrorOverlay(false);
        setReloadAttempt(value => value + 1);
    }, []);

    const exitGame = useCallback(() => {
        navigation.goBack();
    }, [navigation]);

    return {
        webViewKey: `casino-webview-${reloadAttempt}`,
        showErrorOverlay,
        onProcessTerminated,
        retry,
        exitGame,
    };
};
